import { Editor, Element, Node, Path, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { countLayoutAncestors, fitsAt, insertAfterBlock, isInRow, moveItemSettings, wrapInLayout } from './wrap';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

const BLOCK_HOSTS = [types.COLUMN, types.LAYOUT, types.TOGGLE_LIST_BODY, types.INDENTATION];

function buildParagraph() {
  return serializer.utilities.node.paragraph.buildNode();
}

function buildLayout(children) {
  return layoutUtilities.buildNode({ children });
}

export function isEmptyParagraph(editor, node) {
  return node.type === types.DEFAULT && Editor.isEmpty(editor, node) === true;
}

export function hostsBlocks(editor, path) {

  if (path.length === 1) {
    return true;
  }

  return BLOCK_HOSTS.indexOf(Node.parent(editor, path).type) !== -1;

}

function selectStart(editor, path) {
  Transforms.select(editor, Editor.start(editor, path));
}

export function isInsideLayout(editor, path) {

  if (path === null || Node.has(editor, path) === false) {
    return false;
  }

  return countLayoutAncestors(editor, path) > 0;

}

// Whether a new layout can be added at a block: the block sits where top-level blocks go, and
// a new layout there (inside an auto stack, in a row) stays within the depth limit.
export function canInsertAt(editor, path) {

  if (path === null || Node.has(editor, path) === false) {
    return false;
  }

  if (Element.isElement(Node.get(editor, path)) === false || hostsBlocks(editor, path) === false) {
    return false;
  }

  let count = countLayoutAncestors(editor, path);

  if (isInRow(editor, path) === true) {
    count++;
  }

  return fitsAt(count, [buildLayout()]);

}

function replaceEmptyParagraph(editor, path) {

  Editor.withoutNormalizing(editor, function replace() {
    Transforms.insertNodes(editor, buildLayout(), { at: path });
    moveItemSettings(editor, Path.next(path), path);
    Transforms.removeNodes(editor, { at: Path.next(path) });
  });
  selectStart(editor, path.concat(0));

}

function tryWrapWithNewParagraph(editor, path) {

  const wrapper = buildLayout([Node.get(editor, path)]);

  if (layoutUtilities.canNest(countLayoutAncestors(editor, path), wrapper) === false) {
    return false;
  }

  Editor.withoutNormalizing(editor, function wrap() {
    wrapInLayout(editor, path, wrapper);
    Transforms.insertNodes(editor, buildParagraph(), { at: path.concat(1) });
  });
  selectStart(editor, path.concat(1));
  return true;

}

// The insert menu's Layout entry (spec 3.4).
export function insert(editor, path, startOfLine) {

  const node = Node.get(editor, path);

  if (isEmptyParagraph(editor, node) === true) {
    replaceEmptyParagraph(editor, path);
    return;
  }

  if (startOfLine === true && tryWrapWithNewParagraph(editor, path) === true) {
    return;
  }

  const insertedPath = insertAfterBlock(editor, path, [buildLayout()]);

  if (insertedPath !== null) {
    selectStart(editor, insertedPath.concat(0));
  }

}
